import { createReducer } from 'typesafe-actions';
import { AppActions } from '../actions/app';

interface AppState {
    showMainMenu: boolean;
}
const defaultState: AppState = {
    showMainMenu: false,
};

export const appReducer = createReducer<AppState, AppActions>(defaultState).handleAction(
    AppActions.showMainMenu,
    (state, { payload }) => ({ ...state, showMainMenu: payload }),
);
